<template>
  <button
    type="button"
    class="global-canvas-launcher"
    title="打开当前项目画布"
    aria-label="打开当前项目画布"
    @click="openCanvas"
  >
    <i class="el-icon-s-grid" aria-hidden="true"></i>
    <span>画布</span>
  </button>
</template>

<script>
export default {
  name: 'CanvasLauncher',
  methods: {
    openCanvas() {
      const projectId = this.$route.query.id
      if (!projectId) return
      this.$router.push({
        path: '/xiaoyunque/canvas',
        query: {
          projectId: String(projectId),
          ...(this.$route.query.episode ? { episode: this.$route.query.episode } : {}),
          from: this.$route.fullPath,
        },
      })
    },
  },
}
</script>

<style scoped>
.global-canvas-launcher {
  position: fixed;
  top: calc(50% + 72px);
  right: 0;
  z-index: 2490;
  display: inline-flex;
  width: 52px;
  min-height: 52px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 3px;
  padding: 7px 6px;
  border: 1px solid #e3e4e8;
  border-right: 0;
  border-radius: 10px 0 0 10px;
  color: #4f35c9;
  background: #fff;
  box-shadow: -2px 3px 10px rgba(24, 24, 27, 0.12);
  font: inherit;
  cursor: pointer;
  transition: right 180ms ease, color 150ms ease, background 150ms ease, border-color 150ms ease;
}

.global-canvas-launcher i {
  font-size: 18px;
}

.global-canvas-launcher span {
  color: #333;
  font-size: 11px;
  line-height: 14px;
}

.global-canvas-launcher:hover {
  border-color: #cfc6ff;
  color: #6847f5;
  background: #f7f5ff;
}

.global-canvas-launcher:focus-visible {
  outline: 2px solid #7c5cfc;
  outline-offset: 2px;
}

@media (prefers-reduced-motion: reduce) {
  .global-canvas-launcher {
    transition: none;
  }
}
</style>
